import { DefaultButton, DirectionalHint, Dropdown, IDropdownOption, IIconProps, IconButton, Modal, Spinner, SpinnerSize, TeachingBubble, Toggle } from "@fluentui/react";
import { InfoIcon } from "@fluentui/react-icons-mdl2";
import ElementsService, { ElementAmountType, ServiceType, UpdateElementsAmountType } from "../../../services/ElementsService";
import React, { useState } from "react";
import { ai } from "../../../services/TelemetryService";
import PortfolioModelWalletService, { ModelWallet } from "../../../services/PortfolioModelWalletService";
import Auth from "../../../Auth/Auth";
import { useHistory } from "react-router";
import { dropdownStyles } from "../../dropdown/dropdownStyles";
import SavingsPlanService from "../../../services/SavingsPlanService";
import ProcessingModalComponent from "../../Modals/ProcessingModalComponent";
import { ErrorModal } from "../../Modals/ErrorModal";


const cancelIcon: IIconProps = { iconName: "Cancel" };


type Props = { activePlan: any };


const PortfolioBalancer = (props: Props) =>
{
	const theme = window.localStorage.getItem("theme");
	const user = Auth.getUserProfile();
	const appInsights = ai.reactPlugin;
	const history = useHistory();
	const { activePlan } = props;
	const [error, setError] = useState({ status: false, message: "" });
	const [savingPlanModelPortfolios, setSavingPlanModelPortfolios] = useState<IDropdownOption[]>([]);
	const [selectedModelPortfolio, setSelectedModelPortfolio] = useState<IDropdownOption | null>();
	const [showBalanceModelPortfolioModal, setShowBalanceModelPortfolioModal] = useState(false);
	const [balanceModelPortfolioModalChecked, setBalanceModelPortfolioModalChecked] = useState(false);
	const [balancerPortfolioModelPrice, setBalancerPortfolioModelPrice] = useState<ServiceType>();
	const [balancerModelPortfolioToggle, setBalancerModelPortfolioToggle] = useState<boolean>(false);
	const [tooltipBalancer, setTooltipBalancer] = useState(false);
	const [elementsAmount, setElementsAmount] = useState<ElementAmountType>();
	const [loadingBalancerPrice, setLoadingBalancerPrice] = useState<boolean>(true);
	const [loadingModelWallets, setLoadingModelWallets] = useState<boolean>(true);
	const [loadingElementsAmount, setloadingElementsAmount] = useState<boolean>(false);
	const [loadingBalancer, setLoadingBalancer] = useState<boolean>(false);

	const [rebalanceProcessId, setRebalanceProcessId] = useState<number | null>(null);
	const [rebalanceStatus, setRebalanceStatus] = useState<"pending" | "success" | "fail" | null>(null);
	const [rebalanceResultInfo, setRebalanceResultInfo] = useState<any>(null);

	const [isPolling, setIsPolling] = useState(false);


	const intervalRef = React.useRef<NodeJS.Timeout | null>(null);

	React.useEffect(() =>
	{
		let balancePortfolioServiceTypeid = 2;
		setLoadingBalancerPrice(true);
		ElementsService.servicePrice(balancePortfolioServiceTypeid).then((response: ServiceType) =>
		{
			ElementsService.getLastElementsPrice().then(priceResponse =>
			{
				const elementAmountTypeResponse =
				{
					...response,
					elementWater: priceResponse === 0 ? 0 : Number((((response?.elementIA ?? 0) / 100) * (1 / priceResponse)).toFixed(2))
				};
				setBalancerPortfolioModelPrice(elementAmountTypeResponse);
			});
		})
			.finally(() =>
			{
				setLoadingBalancerPrice(false);
			});
	}, []);

	React.useEffect(() =>
	{
		if (activePlan.id)
		{
			setLoadingModelWallets(true);
			PortfolioModelWalletService.getModelWallets(activePlan.id).then((response: ModelWallet[]) =>
			{
				let spModelPortfolios: IDropdownOption[] = response.map((portfolio: ModelWallet) => (
					{
						key: portfolio.id.toString(),
						text: portfolio.name,
						id: portfolio.id.toString()
					}));
				setSavingPlanModelPortfolios(spModelPortfolios);
			})
				.catch((error: any) =>
				{
					setError({ status: true, message: error })
				})
				.finally(() =>
				{
					setLoadingModelWallets(false);
				});
		}
	}, [activePlan.id]);

	React.useEffect(() =>
	{
		if (user.id)
		{
			setloadingElementsAmount(true);
			ElementsService.getElementsAmountBySavingsPlanId(activePlan.id).then((elementsAmountAux: ElementAmountType) =>
			{
				if (elementsAmountAux !== null && elementsAmountAux !== undefined)
				{
					setElementsAmount(elementsAmountAux);
				}
			})
				.catch(() => { })
				.finally(() =>
				{
					setloadingElementsAmount(false);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.id]);

	React.useEffect(() =>
	{
		return () =>
		{
			if (intervalRef.current)
			{
				clearInterval(intervalRef.current);
			}
		};
	}, []);

	const onChangeModelWalletDropDown = (item?: IDropdownOption) =>
	{
		if (item?.id !== undefined)
		{
			setSelectedModelPortfolio(savingPlanModelPortfolios.find(x => x.id === item?.id));
		}
	};

	const buyBalancer = async () =>
	{
		setLoadingBalancer(true);

		if (balancerPortfolioModelPrice)
		{
			appInsights.trackEvent(
				{
					name: "Rebalanceo de cartera",
					properties: { userId: user?.id, planId: activePlan.id, portfolioModelId: selectedModelPortfolio?.id }
				});

			if (haveEnoughElements() == true)
			{
				rebalancearCartera();
			}
			else
			{
				setLoadingBalancer(false);
				setError({ status: true, message: "No tienes suficientes elements para generar el rebalanceo" });
				return;
			}

		}
		else
		{
			setError({ status: true, message: "Lo sentimos algo ha salido mal" })
			setLoadingBalancer(false);
			return;
		}
	};

	const rebalancearCartera = () =>
	{
		if (selectedModelPortfolio?.id !== undefined && selectedModelPortfolio.id !== null)
		{
			setLoadingBalancer(true);
			SavingsPlanService.rebalance(activePlan.id, parseInt(selectedModelPortfolio.id), balancerModelPortfolioToggle == true ? "water" : "IA")
				.then(response =>
				{
					const id = response.processId;
					setRebalanceProcessId(id);
					setRebalanceStatus("pending");

					pollRebalanceStatus(id);
				})
				.catch(() =>
				{
					setError({ status: true, message: "Ha ocurrido un error inesperado al iniciar el rebalanceo" });
					setLoadingBalancer(false);
				});
		}
	};

	const pollRebalanceStatus = (processId: number) =>
	{
		if (isPolling)
		{
			// Ya hay un polling activo, no hagas nada
			return;
		}

		setIsPolling(true);

		// limpiar intervalo previo si existe
		if (intervalRef.current)
		{
			clearInterval(intervalRef.current);
		}

		intervalRef.current = setInterval(async () =>
		{
			try
			{
				const statusResponse = await SavingsPlanService.getRebalanceStatus(processId);

				if (statusResponse.status === 1)
				{
					setRebalanceStatus("success");
					const orders = statusResponse.resultJson;
					setRebalanceResultInfo(orders);

					if (intervalRef.current)
					{
						clearInterval(intervalRef.current);
						intervalRef.current = null;
					}

					setIsPolling(false);

					setLoadingBalancer(false);
					history.push("/portfolio/balancer", { orders: orders ?? [] });

				}
				else if (statusResponse.status === -1)
				{
					setRebalanceStatus("fail");
					const errorMsg = statusResponse.resultJson ?? "Error no especificado";
					setRebalanceResultInfo(errorMsg);

					if (intervalRef.current)
					{
						clearInterval(intervalRef.current);
						intervalRef.current = null;
					}

					setIsPolling(false);

					setLoadingBalancer(false);
					setError({ status: true, message: `Error al procesar el rebalanceo` });
				}
			}
			catch
			{
				if (intervalRef.current)
				{
					clearInterval(intervalRef.current);
					intervalRef.current = null;
				}

				setLoadingBalancer(false);
				setError({ status: true, message: "Error al consultar estado del rebalanceo" });
				setIsPolling(false);
			}
		}, 15000);
	};

	const haveEnoughElements = () =>
	{
		let enoughElements: boolean = false;

		let elements: UpdateElementsAmountType =
		{
			savingsPlanId: activePlan.id,
			concept: "Adquirido rebalanceo de cartera",
			description: "Cartera Modelo: " + selectedModelPortfolio?.text + " - Plan: " + activePlan.name
		};

		if (balancerModelPortfolioToggle)
		{
			let elementsToPay = balancerPortfolioModelPrice?.elementWater!;
			elements.water = -1 * elementsToPay;
			enoughElements = (elementsAmount?.elementWater ?? 0) >= elementsToPay;
		}
		else
		{
			let elementsToPay = balancerPortfolioModelPrice?.elementIA!.toFixed(2);

			elements.iA = -1 * Number(elementsToPay);
			enoughElements = (elementsAmount?.elementIA ?? 0) >= Number(elementsToPay);
		}

		return enoughElements;
	}

	return (
		<React.Fragment>
			<div className="ms-Grid-row" style={{ marginBottom: "15px" }}>
				{!loadingBalancerPrice && !loadingBalancer && !loadingElementsAmount && !loadingModelWallets &&
					(
						<React.Fragment>
							<div className="ms-Grid-col ms-sm12 ms-md4 ms-lg5 ms-xl5 ms-xxl5 ms-xxxl4 text-right" style={{ paddingRight: "10px", margin: "10px 0px" }}>
								Rebalancear contra cartera modelo
							</div>
							<div className="ms-Grid-col ms-sm12 ms-md6 ms-lg5 ms-xl5 ms-xxl5 ms-xxxl6" style={{ paddingRight: "20px", margin: "10px 0px" }}>
								<div className="ms-Grid-row">
									<div className="ms-Grid-col ms-sm11 ms-md11 ms-lg11 ms-xl11 ms-xxl11 ms-xxxl11">
										<Dropdown placeholder={"Selecciona una Cartera Modelo"}
											style={{ width: "100%", marginTop: "-15px" }}
											disabled={showBalanceModelPortfolioModal}
											selectedKey={selectedModelPortfolio?.key ?? undefined}
											options={savingPlanModelPortfolios as IDropdownOption[]}
											onChange={(event, item) =>
											{
												onChangeModelWalletDropDown(item);
											}}
											styles={
												{
													...dropdownStyles,
													root: { width: "100%" },
													title:
													{
														color: "#cc214F !important",
														borderColor: "transparent !important",
														fontWeight: 500,
														fontSize: "16px",
														marginTop: "3px"
													}
												}}
										/>
									</div>
									<div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 ms-xl1 ms-xxl1 ms-xxxl1">
										<InfoIcon id="tooltipBalancerToModelWallet"
											onMouseEnter={() => setTooltipBalancer(true)}
											onMouseLeave={() => setTooltipBalancer(false)}
											style={{ fontSize: "20px", marginTop: "0px" }}
										/>
									</div>
								</div>
							</div>

							<div className="ms-Grid-col ms-sm12 ms-md2 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2">
								<DefaultButton className="button mini-primary-button"
									disabled={!selectedModelPortfolio || !balancerPortfolioModelPrice}
									onClick={() =>
									{
										setShowBalanceModelPortfolioModal(true);
									}}
								>
									Rebalancear
								</DefaultButton>
							</div>
						</React.Fragment>
					)}
				{tooltipBalancer === true &&
					(
						<TeachingBubble
							target="#tooltipBalancerToModelWallet"
							hasCloseButton={false}
							headline=""
							onDismiss={() => setTooltipBalancer(false)}
							calloutProps={{ directionalHint: DirectionalHint.rightCenter }}
						>
							<div>
								El servicio de rebalanceo de carteras permite crear los traspasos necesarios en tu cartera actual para mantener los porcentajes de los
								fondos de la cartera modelo que seleccione.
							</div>
							<br />
							<div>Este servicio tiene un coste en Elements IA o Elements Agua que serán retirados al pulsar el botón rebalancear.</div>
						</TeachingBubble>
					)}
				{showBalanceModelPortfolioModal &&
					(
						<React.Fragment>
							<Modal styles={
								{
									main:
									{
										color: theme === "dark" ? "white" : "black",
										width: "700px !important",
										minWidth: "400px !important",
										height: "auto !important",
										minHeight: "auto !important",
									}
								}}
								isOpen={showBalanceModelPortfolioModal}
								onDismiss={() =>
								{
									setShowBalanceModelPortfolioModal(false);
								}}
								isBlocking={false}
							>
								<div style={{ margin: "15px", display: "inline-block" }}>
									<div style={{ display: "flex", justifyContent: "space-between" }}>
										<div style={{ alignSelf: "center", fontSize: "15px" }}><b>¿Con qué tipo de Elements desea pagar?</b></div>
										<div style={{ justifyContent: "end", display: "flex" }}>
											<IconButton iconProps={cancelIcon}
												ariaLabel="Cerrar"
												className="close-button"
												onClick={() =>
												{
													setShowBalanceModelPortfolioModal(false);
												}}
											/>
										</div>
									</div>
									<div className="ms-Grid-col" style={{ margin: "20px 0px" }}>
										<Toggle
											label={"Elements IA"}
											inlineLabel
											onText="Elements Agua"
											offText="Elements Agua"
											checked={balancerModelPortfolioToggle}
											onChange={(ev, checked) =>
											{
												setBalancerModelPortfolioToggle(checked ?? false);
											}}
											styles={
												{
													root: { margin: 0 },
													label: { margin: 0, paddingBottom: 0, paddingTop: "0px", paddingRight: "10px" },
													container: { paddingTop: "0px", alignItems: "center" }
												}}
										/>
									</div>
									<p>
										Acabas de seleccionar rebalancear tu cartera actual a la cartera modelo <b>{selectedModelPortfolio?.text}</b>, si pulsas el
										botón aceptar se retirarán{" "}
										<b>
											{balancerModelPortfolioToggle
												? balancerPortfolioModelPrice?.elementWater + " Elements Agua "
												: balancerPortfolioModelPrice?.elementIA + " Elements IA "}
										</b>
										de tu cuenta.
									</p>
									<p>En la pantalla siguiente aparecerán los traspasos que se van a realizar para su firma.</p>
									<div style={
										{
											backgroundColor: "#FFF1BE",
											boxShadow: "rgb(0 0 0 / 25%) 0.5px 1px 2px",
											padding: "10px",
											borderRadius: "10px"
										}}
									>
										<input type="checkbox"
											style={{ marginRight: "10px" }}
											onChange={e =>
											{
												setBalanceModelPortfolioModalChecked(e.target.checked);
											}}
										/>
										Acepto que se retiren{" "}
										<b>
											{balancerModelPortfolioToggle
												? balancerPortfolioModelPrice?.elementWater + " Elements Agua "
												: balancerPortfolioModelPrice?.elementIA + " Elements IA "}
										</b>
										de mi cuenta que no se devolverán en caso de no firmar los traspasos por cualquier motivo, salvo incidencia técnica del
										proceso notificada por correo eléctrónico a info@ironia.tech.
									</div>
									<div style={{ marginTop: "20px", float: "right" }}>
										<DefaultButton className="button mini-primary-button"
											style={{ marginRight: "10px" }}
											onClick={() =>
											{
												setBalanceModelPortfolioModalChecked(false);
												setShowBalanceModelPortfolioModal(false);
												buyBalancer();
											}}
											disabled={
												!selectedModelPortfolio || !balanceModelPortfolioModalChecked || !balancerPortfolioModelPrice || !elementsAmount
											}
										>
											{loadingBalancer && <Spinner size={SpinnerSize.small} style={{ marginRight: "5px" }} />}
											Aceptar
										</DefaultButton>
									</div>
								</div>
							</Modal>
						</React.Fragment>
					)}
				<ProcessingModalComponent isModalOpen={loadingBalancer}
					hideModal={() => { setLoadingBalancer(false) }}
					blocking={true}
					title='Procesando Rebalanceo'
					description='Esta operación puede tardar varios minutos, no cierre el navegador para que el proceso continue ejecutándose. Porfavor, tampoco refresque ya que esto hará que se interrumpa el proceso.'
				/>
				<ErrorModal title="Ha ocurrido un error al procesar tu solicitud"
					body={
						<div>
							<p>{error.message}</p>
						</div>
					}
					btnSubmitText="Aceptar"
					showModal={error.status}
					onSubmit={() =>
					{
						setError({ status: false, message: "" });
					}}
					onClose={() =>
					{
						setError({ status: false, message: "" });
					}}
				/>
			</div>
		</React.Fragment>
	);
};


export default PortfolioBalancer;